export const server = {
    baseURL: process.env.VUE_APP_SERVER_URL
}